export default {
  namespaced: true,
  state: () => ({
    access: {},
  }),
  mutations: {
    setAccess(state, data) {
      state.access = data || {};
    },
  },
  getters: {
    access(state) {
      return state.access;
    },
  },
};
